module.exports = __webpack_public_path__ + "img/2025-09-19b_1.15a0d9a2.jpg";